module.exports = "/_next/static/files/44da7eea474fa335d15b58d90451719e.svg";